export default __webpack_public_path__ + "static/giaoduc-dd58ab2209a249b1fed83b45ee5dc666.jpg";